/**
 * openExternal.ts
 *
 * Opens a URL in the system browser on native (Capacitor), or a new
 * tab on web. Used by any component with an outbound link (directions,
 * venue website, event ticket links, etc.) — moved out of AppShell.tsx,
 * which it had no real relationship to beyond having been added there
 * first. Six unrelated components importing a utility out of the root
 * layout component meant any AppShell change (nav, onboarding, age
 * gate) was one accidental edit away from breaking outbound links
 * across the app.
 */
export async function openExternal(url: string) {
  const native = !!(window as any).Capacitor?.isNativePlatform?.()
  if (native) {
    try {
      const { Browser } = await import('@capacitor/browser')
      await Browser.open({ url })
    } catch {
      window.open(url, '_blank')
    }
  } else {
    window.open(url, '_blank')
  }
}
